export default "/assets/images/housekeeping-service.2b106e234a71d7ff.mp4";